import { CloseFilled } from '@icon';
import React from 'react';
import { IndicatorProps, OptionTypeBase } from 'react-select';
import { useTheme } from 'styled-components';

const ClearIndicator = <OptionType extends OptionTypeBase, IsMulti extends boolean>(
  props: IndicatorProps<OptionType, IsMulti>,
) => {
  const theme = useTheme();

  const {
    children = <CloseFilled width={20} height={20} color={theme.color.tint.tertiary} />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles('clearIndicator', props) as React.CSSProperties}
    >
      {children}
    </div>
  );
};

export default ClearIndicator;
